import FormattedDateTime from 'I18n/components/FormattedDateTime';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'I18n... Remove this comment to see the full error message
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ONE_MINUTE, ONE_DAY, ONE_YEAR } from '../constants/Dates';
import { useRelativeDurationWithInterval } from '../hooks/useRelativeDurationWithInterval';
import { PreviewCardTimestampWrapper } from './PreviewCardStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const RelativeTimestamp = ({
  timestamp
}) => {
  const duration = useRelativeDurationWithInterval(timestamp);
  if (duration < ONE_MINUTE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-workspace-ui-lib.preview-card.header-timestamp.now"
    });
  }
  return /*#__PURE__*/_jsx(FormattedDuration
  // apply duration as a key to ensure the `FormattedDuration` updates on new durations
  , {
    from: timestamp,
    type: "userTz",
    format: "short"
  }, duration);
};
RelativeTimestamp.displayName = 'RelativeTimestamp';
const AbsoluteTimestamp = ({
  timestamp,
  date
}) => {
  const duration = date && date > timestamp ? date - timestamp : Date.now() - timestamp;
  const format = duration <= ONE_YEAR ? 'short-date' : 'L';
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    value: timestamp,
    type: "userTz",
    format: format
  });
};
AbsoluteTimestamp.displayName = 'AbsoluteTimestamp';
const PreviewCardTimestamp = ({
  renderAbsoluteTimestampOverride,
  timestamp,
  date = Date.now(),
  color
}) => {
  const duration = date - timestamp;
  const renderAbsoluteTimestamp = duration >= ONE_DAY || renderAbsoluteTimestampOverride;
  return /*#__PURE__*/_jsx(PreviewCardTimestampWrapper, {
    color: color,
    children: renderAbsoluteTimestamp ? /*#__PURE__*/_jsx(AbsoluteTimestamp, {
      date: date,
      timestamp: timestamp
    }) : /*#__PURE__*/_jsx(RelativeTimestamp, {
      timestamp: timestamp
    })
  });
};
PreviewCardTimestamp.displayName = 'PreviewCardTimestamp';
export default PreviewCardTimestamp;